// Server Error Test - Only runs when ?server-test=true is in URL
(function () {
  "use strict";

  // Only run if server-test parameter is present
  if (!window.location.search.includes("server-test=true")) {
    return;
  }

  console.log("🔍 Server Error Test Running...");

  function testCartAdd() {
    console.log("=== Testing Cart Add ===");

    // Get the variant ID from the page
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) {
      console.error("❌ No variant input found");
      return;
    }

    const variantId = variantInput.value;
    console.log("Variant ID:", variantId);

    if (!variantId) {
      console.error("❌ No variant ID value");
      return;
    }

    // Test 1: Basic cart.js request
    console.log("--- Test 1: Basic cart.js request ---");
    fetch("/cart.js")
      .then((response) => {
        console.log("✅ Cart.js status:", response.status);
        return response.json();
      })
      .then((data) => {
        console.log("✅ Cart.js data:", data);
      })
      .catch((error) => {
        console.error("❌ Cart.js error:", error);
      });

    // Test 2: Cart add with minimal data
    console.log("--- Test 2: Cart add with minimal data ---");
    const minimalFormData = new FormData();
    minimalFormData.append("id", variantId);
    minimalFormData.append("quantity", "1");

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      body: minimalFormData,
    })
      .then((response) => {
        console.log("✅ Minimal add status:", response.status);
        console.log("✅ Minimal add headers:", response.headers);
        return response.text();
      })
      .then((text) => {
        console.log("✅ Minimal add response:", text);
        try {
          const json = JSON.parse(text);
          console.log("✅ Minimal add JSON:", json);
        } catch (e) {
          console.log("✅ Minimal add response is not JSON");
        }
      })
      .catch((error) => {
        console.error("❌ Minimal add error:", error);
      });

    // Test 3: Cart add with sections (like the real form)
    console.log("--- Test 3: Cart add with sections ---");
    const fullFormData = new FormData();
    fullFormData.append("id", variantId);
    fullFormData.append("quantity", "1");
    fullFormData.append("sections", "cart-drawer");
    fullFormData.append("sections_url", window.location.pathname);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json, text/plain, */*",
        "Cache-Control": "no-cache",
      },
      credentials: "same-origin",
      body: fullFormData,
    })
      .then((response) => {
        console.log("✅ Full add status:", response.status);
        console.log("✅ Full add headers:", response.headers);
        return response.text();
      })
      .then((text) => {
        console.log("✅ Full add response:", text);
        try {
          const json = JSON.parse(text);
          console.log("✅ Full add JSON:", json);
        } catch (e) {
          console.log("✅ Full add response is not JSON");
        }
      })
      .catch((error) => {
        console.error("❌ Full add error:", error);
      });

    // Test 4: Check product availability
    console.log("--- Test 4: Check product availability ---");
    fetch(`/products/rvt-digitizer.js`)
      .then((response) => response.json())
      .then((product) => {
        console.log("✅ Product data:", product);
        const variant = product.variants.find(
          (v) => v.id.toString() === variantId
        );
        if (variant) {
          console.log("✅ Variant found:", variant);
          console.log("✅ Available:", variant.available);
          console.log("✅ Inventory quantity:", variant.inventory_quantity);
          console.log("✅ Inventory policy:", variant.inventory_policy);
        } else {
          console.error("❌ Variant not found");
        }
      })
      .catch((error) => {
        console.error("❌ Product fetch error:", error);
      });
  }

  // Add test button
  const testBtn = document.createElement("button");
  testBtn.textContent = "🔍 Test Server";
  testBtn.style.cssText = `
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 10000;
    padding: 10px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 14px;
  `;

  testBtn.onclick = testCartAdd;
  document.body.appendChild(testBtn);

  // Run test automatically after page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(testCartAdd, 2000);
    });
  } else {
    setTimeout(testCartAdd, 2000);
  }

  console.log(
    '🔍 Server test setup complete. Click the red "Test Server" button to run tests.'
  );
})();
